var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHearts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122 191",
    style: {
      enableBackground: "new 0 0 122 191"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "two_three"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9,138.8c2,7.3,7.4,9.4,7.3,14.3c0,2.3-1.6,3.7-3.7,3.7c-2,0-3.7-1.6-3.7-3.7c0,2-1.6,3.7-3.7,3.7s-3.7-1.3-3.7-3.7 C53.5,148.2,58.9,146.2,60.9,138.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,53.5c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C53.6,44.2,59,46.2,61,53.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "three_nine_five_nine"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9,103.8c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C53.5,94.5,58.9,96.5,60.9,103.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "four_five_six_seven_eight_nine_ten"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9,138.8c2,7.3,7.4,9.4,7.3,14.3c0,2.3-1.6,3.7-3.7,3.7c-2,0-3.7-1.6-3.7-3.7c0,2-1.6,3.7-3.7,3.7s-3.7-1.3-3.7-3.7 C38.5,148.2,43.9,146.2,45.9,138.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9,138.8c2,7.3,7.4,9.4,7.3,14.3c0,2.3-1.6,3.7-3.7,3.7s-3.7-1.6-3.7-3.7c0,2-1.6,3.7-3.7,3.7s-3.7-1.3-3.7-3.7 C68.5,148.2,73.9,146.2,75.9,138.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9,53.5c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C38.5,44.2,43.9,46.2,45.9,53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9,53.5c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7s-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C68.5,44.2,73.9,46.2,75.9,53.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "seven"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61,78.8c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C53.6,69.5,59,71.5,61,78.8z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "eight"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61,110.8c2,7.3,7.4,9.4,7.3,14.3c0,2.3-1.6,3.7-3.7,3.7c-2,0-3.7-1.6-3.7-3.7c0,2-1.6,3.7-3.7,3.7s-3.7-1.3-3.7-3.7 C53.6,120.2,59,118.2,61,110.8z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "six_seven_eight"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7,104.4c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7s-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7c-2,0-3.7,1.3-3.7,3.7 C38.2,95,43.7,97.1,45.7,104.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,104.4c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C68.2,95,73.7,97.1,75.7,104.4z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "nine_ten"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7,103.4c2,7.3,7.4,9.4,7.3,14.3c0,2.3-1.6,3.7-3.7,3.7s-3.7-1.6-3.7-3.7c0,2-1.6,3.7-3.7,3.7c-2,0-3.7-1.3-3.7-3.7 C38.2,112.8,43.7,110.7,45.7,103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,103.4c2,7.3,7.4,9.4,7.3,14.3c0,2.3-1.6,3.7-3.7,3.7c-2,0-3.7-1.6-3.7-3.7c0,2-1.6,3.7-3.7,3.7s-3.7-1.3-3.7-3.7 C68.2,112.8,73.7,110.7,75.7,103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7,87.4c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7s-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7c-2,0-3.7,1.3-3.7,3.7 C38.2,78,43.7,80.1,45.7,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,87.4c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C68.2,78,73.7,80.1,75.7,87.4z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "ten"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61,120.5c2,7.3,7.4,9.4,7.3,14.3c0,2.3-1.6,3.7-3.7,3.7c-2,0-3.7-1.6-3.7-3.7c0,2-1.6,3.7-3.7,3.7s-3.7-1.3-3.7-3.7 C53.6,129.9,59,127.8,61,120.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,70.5c2-7.3,7.4-9.4,7.3-14.3c0-2.3-1.6-3.7-3.7-3.7c-2,0-3.7,1.6-3.7,3.7c0-2-1.6-3.7-3.7-3.7s-3.7,1.3-3.7,3.7 C53.6,61.1,59,63.2,61,70.5z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 122,
    height: 191
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7,73.9c3-11,11.2-14.1,11-21.5c0-3.5-2.5-5.5-5.5-5.5s-5.5,2.5-5.5,5.5c0-3-2.5-5.5-5.5-5.5s-5.5,2-5.5,5.5 C8.5,59.8,16.7,62.9,19.7,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.7,116.9c3,11,11.2,14.1,11,21.5c0,3.5-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0,3-2.5,5.5-5.5,5.5s-5.5-2-5.5-5.5 C90.5,130.9,98.7,127.9,101.7,116.9z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "ace"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 -54.8596 108.4135)",
    cx: 66.5,
    cy: 101.7,
    rx: 0.7,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1,112.3c1.7-1.4,2.9-3,3-4.5c-0.9,0.5-2.1,0.9-3.4,1c-0.9-4.2-3.1-9-6.6-14.1c5.5,0.4,11.1,2.5,16.4,5.9 c5.4-7.1,10.4-12.6,10.2-20.6c0-6.7-4.7-10.8-10.8-10.8C66,69.2,61,73.8,61,80c0-5.9-4.7-10.8-10.8-10.8C44,69.2,39.3,73,39.3,80 c0.3,14.2,15.1,20.1,21.3,39.8C62.4,117.8,63.2,115.3,63.1,112.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2,121.7c0,0,0,0.1,0,0.1C61.3,121.8,61.3,121.7,61.2,121.7C61.3,121.7,61.3,121.7,61.2,121.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearts);
export default __webpack_public_path__ + "static/media/hearts.979ff4a5b4b086138e0ed3259a240386.svg";
export { ForwardRef as ReactComponent };